module.exports = __webpack_public_path__ + "static/img/9.eeaf6ff.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/5/zh/9.png
// module id = rG+5
// module chunks = 0